import type { FC, Ref } from "react";

import { Flex } from "../Flex/Flex";
import { formRowGroupStyle } from "./FormRowGroup.css";
import type { ChildrenProp } from "../../props";

export type FormRowGroupProps = ChildrenProp & {
  //
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const FormRowGroup: FC<FormRowGroupProps> = ({ children, ref }) => (
  <Flex ref={ref} gap="xs" direction="column" className={formRowGroupStyle}>
    {children}
  </Flex>
);
